const { amountList, currency } = window.settings;

export const AMOUNTS_LIST = amountList;
export const MIN_AMOUNT = amountList[0];
export const MIN_PAN_LENGTH = 16;
export const CURRENCY_VIEW = currency === 'RUB' ? '₽' :
    currency === 'NGN' ? '₦' : 
    currency;